import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import { CustomOrderApiResponse } from './types';

interface Params {
    gigSlug?: string;
    includeHidden?: boolean;
}

export const fetchCustomOrderFormData = async (
    sellerUsername: string,
    { gigSlug, includeHidden }: Params = {}
): Promise<CustomOrderApiResponse> => {
    const url = pathfinder('new_custom_order_request_form', {
        seller: sellerUsername,
        ...(gigSlug && { gig: gigSlug }),
    });
    const params = includeHidden ? { include_hidden: true } : {};

    try {
        const { data } = await axios.get<CustomOrderApiResponse>(url, {
            params,
        });

        return data;
    } catch (error) {
        logger.error(new Error('Failed to fetch custom order data'), {
            sellerUsername,
            cause: error,
        });

        throw error;
    }
};
